import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {getAllSamples, setSample} from "../../slices/SampleFunctionalSlice";
import {setCurrentSampleId} from "../../slices/SampleSlice/SampleSlice";
import {getAllUsers, getCurrentUser, getUsers} from "../../slices/UserSlice";
import {checkEmptyFields} from "../../utilities/checkEmptyFields";
import useDynamicPageContainer from "../DynamicPageContainer/useDynamicPageContainer";

const useSamplesListNew = ({setTabs, setTabValue}) => {
  const dispatch = useDispatch();

  const currUser = useSelector(getCurrentUser);

  const [currentSample, setCurrentSample] = useState(null);

  const users = useSelector(getUsers);

  useEffect(() => {
    if (!users?.length) {
      dispatch(getAllUsers());
    }
  }, []);

  useEffect(() => {
    setTabs(prev => {
      if (prev.length === 1) {
        dispatch(setSample(null));
      }
      return prev;
    });
  }, []);

  const {formType, setFormType, setTabProps, setTabLabel} = useDynamicPageContainer({setTabs, setTabValue});

  const fetchSamples = values => {
    dispatch(setCurrentSampleId(null));
    if (!values) {
      dispatch(getAllSamples({page: 1, isFree: true}));
      return;
    }
    const filters = checkEmptyFields(values);
    dispatch(getAllSamples({...filters, page: 1, isFree: true}));
  };

  return {
    currUser,
    currentSample,
    setCurrentSample,
    setTabLabel,
    setTabProps,
    formType,
    setFormType,
    fetchSamples,
  };
};

export default useSamplesListNew;
